import VrrVrrCircleLoader from './VrrCircleLoader';

export default VrrVrrCircleLoader;
